/* eslint-disable no-plusplus */
/* eslint-disable new-cap */
/* eslint-disable react/prop-types */
import React, { useContext } from "react";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import moment from "moment";
import styles from "./ExportButton.styles";
import Button from "../../../../components/common/Button/index";
// import Reports from "../../../../services/api/reports";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";

function ExportButton({ data, exportFunction }) {
  const toast = useContext(ToastAlertContext);
  // const [id, setId] = useState(null);
  // const [fullName, setFullName] = useState(null);
  const location = useLocation();
  // useEffect(() => {
  //   const queryParams = new URLSearchParams(location.search);
  //   const Id = queryParams.get("id");
  //   setId(Id);
  //   const FullName = queryParams.get("fullName");
  //   setFullName(FullName);
  // }, [location.search]);
  const handleExport = async () => {
    const queryParams = new URLSearchParams(location.search);
    console.log("queryParams", queryParams);
    try {
      // mainlinePositionIds
      const mainlinePositionIdsQueryParam = queryParams.get(
        "mainlinePositionIds"
      );
      const mainlinePositionIds = mainlinePositionIdsQueryParam
        ? mainlinePositionIdsQueryParam
            .split(",")
            .map((id) => parseInt(id, 10))
            .filter(Boolean)
        : [];

      // dualPositionIds
      const dualPositionIdsQueryParam = queryParams.get("dualPositionIds");
      const dualPositionIds = dualPositionIdsQueryParam
        ? dualPositionIdsQueryParam
            .split(",")
            .map((id) => parseInt(id, 10))
            .filter(Boolean)
        : [];

      // gohonzonTypes
      const gohonzonTypesQueryParam = queryParams.get("gohonzonTypes");
      const gohonzonTypes = gohonzonTypesQueryParam
        ? gohonzonTypesQueryParam
            .split(",")
            // .map((id) => parseInt(id, 10))
            .filter(Boolean)
        : [];

      // conferralDateFrom
      const conferralDateFromQueryParam = queryParams.get("conferralDateFrom");
      const conferralDateFrom = conferralDateFromQueryParam
        ? moment(conferralDateFromQueryParam, "DD-MMM-YYYY").format(
            "YYYY-MM-DD"
          )
        : "";

      // conferralDateTo
      const conferralDateToQueryParam = queryParams.get("conferralDateTo");
      const conferralDateTo = conferralDateToQueryParam
        ? moment(conferralDateToQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // dateOfJoiningFrom
      const dateOfJoiningFromQueryParam = queryParams.get("dateOfJoiningFrom");
      const dateOfJoiningFrom = dateOfJoiningFromQueryParam
        ? moment(dateOfJoiningFromQueryParam, "DD-MMM-YYYY").format(
            "YYYY-MM-DD"
          )
        : "";

      // dateOfJoiningTo
      const dateOfJoiningToQueryParam = queryParams.get("dateOfJoiningTo");
      const dateOfJoiningTo = dateOfJoiningToQueryParam
        ? moment(dateOfJoiningToQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // dateOfBirthFrom
      const dateOfBirthFromQueryParam = queryParams.get("dateOfBirthFrom");
      const dateOfBirthFrom = dateOfBirthFromQueryParam
        ? moment(dateOfBirthFromQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // dateOfBirthTo
      const dateOfBirthToQueryParam = queryParams.get("dateOfBirthTo");
      const dateOfBirthTo = dateOfBirthToQueryParam
        ? moment(dateOfBirthToQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // applicationFrom
      const applicationFromQueryParam = queryParams.get("applicationFrom");
      const applicationFrom = applicationFromQueryParam
        ? moment(applicationFromQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // applicationTo
      const applicationToQueryParam = queryParams.get("applicationTo");
      const applicationTo = applicationToQueryParam
        ? moment(applicationToQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // allotmentFrom
      const allotmentFromQueryParam = queryParams.get("allotmentFrom");
      const allotmentFrom = allotmentFromQueryParam
        ? moment(allotmentFromQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // allotmentTo
      const allotmentToQueryParam = queryParams.get("allotmentTo");
      const allotmentTo = allotmentToQueryParam
        ? moment(allotmentToQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // conferredFrom
      const conferredFromQueryParam = queryParams.get("conferredFrom");
      const conferredFrom = conferredFromQueryParam
        ? moment(conferredFromQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // conferredTo
      const conferredToQueryParam = queryParams.get("conferredTo");
      const conferredTo = conferredToQueryParam
        ? moment(conferredToQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // dateFrom
      const dateFromQueryParam = queryParams.get("dateFrom");
      const dateFrom = dateFromQueryParam
        ? moment(dateFromQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // dateTo
      const dateToQueryParam = queryParams.get("dateTo");
      const dateTo = dateToQueryParam
        ? moment(dateToQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // appointedAtFrom
      const appointedAtFromQueryParam = queryParams.get("appointedAtFrom");
      const appointedAtFrom = appointedAtFromQueryParam
        ? moment(appointedAtFromQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // appointedAtTo
      const appointedAtToQueryParam = queryParams.get("appointedAtTo");
      const appointedAtTo = appointedAtToQueryParam
        ? moment(appointedAtToQueryParam, "DD-MMM-YYYY").format("YYYY-MM-DD")
        : "";

      // roleIds
      const roleIdsQueryParam = queryParams.get("roleIds");
      const roleIds = roleIdsQueryParam
        ? roleIdsQueryParam
            .split(",")
            .map((id) => parseInt(id, 10))
            .filter(Boolean)
        : [];

      // eslint-disable-next-line no-unused-vars
      const payload = {
        id: queryParams.get("id") || null,
        fullName: queryParams.get("fullName") || null,
        emailId: queryParams.get("emailId") || null,
        mobileNumber: queryParams.get("mobileNumber") || null,
        addressLine1: queryParams.get("addressLine1") || null,
        divisionId: queryParams.get("divisionId") || null,
        subDivisionId: queryParams.get("subDivisionId") || null,
        specialGroupId: queryParams.get("specialGroupId") || null,
        // dateOfJoiningFrom: queryParams.get("dateOfJoiningFrom") || null,
        dateOfJoiningFrom: dateOfJoiningFrom || null,
        // dateOfJoiningTo: queryParams.get("dateOfJoiningTo") || null,
        dateOfJoiningTo: dateOfJoiningTo || null,
        // dateOfBirthFrom: queryParams.get("dateOfBirthFrom") || null,
        dateOfBirthFrom: dateOfBirthFrom || null,
        // dateOfBirthTo: queryParams.get("dateOfBirthTo") || null,
        dateOfBirthTo: dateOfBirthTo || null,
        cityId: queryParams.get("cityId") || null,
        stateId: queryParams.get("state") || null,
        professionsId: queryParams.get("professionsId") || null,
        status: queryParams.get("status") || null,
        areaId: queryParams.get("areaId") || null,
        zoneId: queryParams.get("zoneId") || null,
        regionId: queryParams.get("regionId") || null,
        chapterId: queryParams.get("chapterId") || null,
        districtId: queryParams.get("districtId") || null,
        blockId: queryParams.get("blockId") || null,
        // gohonzonTypes: queryParams.get("gohonzonTypes") || null,
        gohonzonTypes,
        // conferralDateFrom: queryParams.get("conferralDateFrom") || null,
        conferralDateFrom: conferralDateFrom || null,
        // conferralDateTo: queryParams.get("conferralDateTo") || null,
        conferralDateTo: conferralDateTo || null,
        // mainlinePositionIds: queryParams.get("mainlinePositionIds") || null,
        mainlinePositionIds,
        // dualPositionIds: queryParams.get("dualPositionIds") || null,
        dualPositionIds,
        // appointedAtFrom: queryParams.get("appointedAtFrom") || null,
        appointedAtFrom: appointedAtFrom || null,
        // appointedAtTo: queryParams.get("appointedAtTo") || null,
        appointedAtTo: appointedAtTo || null,
        memberId: queryParams.get("memberId") || null,
        // applicationFrom: queryParams.get("applicationFrom") || null,
        applicationFrom: applicationFrom || null,
        // applicationTo: queryParams.get("applicationTo") || null,
        applicationTo: applicationTo || null,
        // allotmentFrom: queryParams.get("allotmentFrom") || null,
        allotmentFrom: allotmentFrom || null,
        // allotmentTo: queryParams.get("allotmentTo") || null,
        allotmentTo: allotmentTo || null,
        conferredFrom: conferredFrom || null,
        conferredTo: conferredTo || null,
        dateFrom: dateFrom || null,
        dateTo: dateTo || null,
        roleIds,
        honoraryDistrictChief:
          queryParams.get("honoraryDistrictChief") || false,
      };

      // const response = await Reports.downloadMembersReport({
      //   data: payload,
      // });
      const response = await exportFunction({
        data: payload,
      });
      const { name } = response.data;
      if (response.code === 200) {
        toast.show(
          `${name} will be available shortly under downloads`,
          AlertStatus.SUCCESS
        );
      }
    } catch (error) {
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      Sentry.captureException(error);
    }
  };

  const disabled = !data || !data.length;

  return (
    <Box style={{ ...styles.dropdown, ...(disabled ? styles.disabled : {}) }}>
      <Box style={styles.dropdownBtn}>
        {" "}
        <Button
          variant="outlined"
          style={styles.leftSideBtn}
          onClick={handleExport}
          label="Download Reports"
          startIcon={
            <SaveAltIcon
              sx={{
                fontSize: "18px",
                fontWeight: "100",
              }}
            />
          }
        />
        <Box sx={styles.arrowIcon}>
          <ArrowDropDownIcon />
        </Box>
      </Box>
    </Box>
  );
}

export default ExportButton;
